<template>
  <footer class="app_footer">
    <div class="text_part">
      Eligibility and approval is subject to standard credit assessment and not
      all amounts, term lengths or rates will be available to all applicants.
      Fees, terms and conditions apply.
    </div>
    <!-- <div class="text_part">
      Heartland’s lending criteria, terms and conditions and fees apply.
    </div> -->
    <div class="copyright">
      &copy; Copyright {{ date }} Heartland Bank Limited
    </div>
  </footer>
</template>

<script>
export default {
  props: ["app_step"],
  data() {
    return {
      date: new Date().getFullYear(),
    };
  },
};
</script>
